import ApiBase from '../ApiBase';

export default new class Questions extends ApiBase {
    route = '/surveys/:survey/sections/:section/questions';
};
